import { FORM_DEFINITIONS, FORM_TYPES, type OnboardingFormType } from "./onboardingForms.js";

/** Operational paperwork stays crawlable so bots can read its noindex directive. */
export const FORMS_ROUTE_PATTERN = new RegExp(`^/forms(?:/(?:${FORM_TYPES.join("|")}))?/?$`);

export function getFormsPageSeo(path: string) {
  if (!FORMS_ROUTE_PATTERN.test(path)) return null;
  const canonicalPath = path.replace(/\/+$/, "");
  const formType = canonicalPath.split("/")[2] as OnboardingFormType | undefined;
  return {
    path: canonicalPath,
    title: formType ? FORM_DEFINITIONS[formType].title : "Customer Onboarding Forms",
    description: formType
      ? FORM_DEFINITIONS[formType].description
      : "Access Premier Pharma customer onboarding forms and account paperwork.",
  };
}
